/** 过滤班次选项（分钟，0=不过滤） */
export const LINE_CLASS_TIME_FILTER_OPTIONS = [
  { label: "不过滤", minutes: 0 },
  { label: "过滤10分钟前", minutes: 10 },
  { label: "过滤30分钟前", minutes: 30 },
  { label: "过滤1小时前", minutes: 60 },
  { label: "过滤2小时前", minutes: 120 },
];

const VALID_FILTER_MINUTES = new Set(
  LINE_CLASS_TIME_FILTER_OPTIONS.map((item) => item.minutes)
);

export const NODE_LIST_SELECTED_STATION_KEY = "nodeListSelectedStation";
export const NODE_LIST_LINE_CLASS_FILTER_KEY = "nodeListLineClassFilter";

/** 解析 VehicleDriverList（兼容字符串 JSON 与数组） */
export function parseVehicleDriverList(raw) {
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "string" || !raw.trim()) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

/** 按发车时间过滤已过期班次 */
export function filterLineClassByDepartTime(
  list,
  filterMinutes,
  classDate,
  moment
) {
  if (!filterMinutes) return list;

  const cutoff = moment().subtract(filterMinutes, "minute");
  return list.filter((item) => {
    const time = (item.ClassTime || "").substr(0, 5);
    const departAt = moment(`${classDate} ${time}`, "YYYY-MM-DD HH:mm");
    if (!departAt.isValid()) return true;
    return departAt.isAfter(cutoff) || departAt.isSame(cutoff);
  });
}

export function loadSelectedStation() {
  try {
    const raw = window.localStorage.getItem(NODE_LIST_SELECTED_STATION_KEY);
    if (!raw) return null;
    const item = JSON.parse(raw);
    return item && item.NodeGID ? item : null;
  } catch (e) {
    return null;
  }
}

export function saveSelectedStation(item) {
  if (!item || !item.NodeGID) return;
  window.localStorage.setItem(
    NODE_LIST_SELECTED_STATION_KEY,
    JSON.stringify({
      NodeGID: item.NodeGID,
      NodeName: item.NodeName || "",
    })
  );
}

export function loadLineClassTimeFilter() {
  const raw = window.localStorage.getItem(NODE_LIST_LINE_CLASS_FILTER_KEY);
  const minutes = Number(raw);
  if (VALID_FILTER_MINUTES.has(minutes)) return minutes;
  return 0;
}

export function saveLineClassTimeFilter(minutes) {
  if (!VALID_FILTER_MINUTES.has(minutes)) return;
  window.localStorage.setItem(NODE_LIST_LINE_CLASS_FILTER_KEY, String(minutes));
}

/** 收藏置顶：collectNodeList 中的站点排在前面 */
export function sortStationsWithCollect(list, collectNodeList) {
  if (!collectNodeList || !collectNodeList.length) return list;

  const favGids = new Set(collectNodeList.map((item) => item.NodeGID));
  const favorites = [];
  const others = [];

  list.forEach((item) => {
    if (favGids.has(item.NodeGID)) favorites.push(item);
    else others.push(item);
  });

  favorites.sort((a, b) => {
    const indexA = collectNodeList.findIndex((c) => c.NodeGID === a.NodeGID);
    const indexB = collectNodeList.findIndex((c) => c.NodeGID === b.NodeGID);
    return indexA - indexB;
  });

  return [...favorites, ...others];
}

/** 按关键词过滤站点名称 */
export function filterStationsByKeyword(list, keyword) {
  const q = (keyword || "").trim();
  if (!q) return list;
  return list.filter((item) => (item.NodeName || "").includes(q));
}
